import styled, { css } from 'styled-components';

interface IButton {
  selected: boolean;
}

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.spacings[16]};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[12]};

    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.colors.gray50};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.blue700};
    }

    > header {
      margin-bottom: ${theme.spacings[8]};
    }
  `}
`;

export const Content = styled.div`
  ${({ }) => css`
    width: 100%;

    .category-title {
      display: inline-flex;
      align-items: center;
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[8]};
    margin-bottom: ${theme.spacings[12]};
    gap: ${theme.spacings[6]};
  `}
`;

export const ToolsButton = styled.button<IButton>`
  ${({ selected }) => css`
    padding: 5px 15px 5px 15px;

    display: flex;
    align-items: center;

    &:hover {
      color: #03a9f4;
    }

    &:disabled {
      pointer-events: none;
    }

    @media (max-width: 600px) {
      font-size: 10px;
    }

    .icons-sidebar {
      font-size: 32px;

      @media (max-width: 1600px) {
        font-size: 24px;
      }

      @media (max-width: 600px) {
        font-size: 20px;
      }

      margin-right: 10px;
    }

    .dropdown-arrow {
      margin-left: auto;
    }

    border: 0;

    margin-bottom: 2px;
    width: 100%;

    transition: background-color 0.3s ease;
    background-color: ${selected ? '#ddddddff' : '#EFEFEF'};
    border-radius: 12px;
  `}
`;

export const TitleTooltipTools = styled.span`
  font-size: 12px;
  font-style: normal;
  max-width: 100px;
`;


interface DirectionButtonProps {
  active?: boolean;
}

export const DirectionSelector = styled.div`
  display: flex;
  gap: 8px;
`;

export const DirectionButton = styled.button<DirectionButtonProps>`
  ${({ active, theme }) => css`
    flex: 1;
    padding: 8px 0;
    border-radius: 8px;
    border: 1px solid #d5dbe7;
    background: ${active ? theme.colors.blue700 : '#f4f6fb'};
    color: ${active ? '#fff' : '#333'};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${active ? theme.colors.blue700 : '#e8f0ff'};
      border-color: ${theme.colors.blue700};
    }
  `}
`;
